"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const typography_1 = require("../typography");
const styles_1 = require("./styles");
exports.TextArea = (0, react_1.forwardRef)((props, ref) => {
    const { label, helperText = undefined, messageType = undefined, isRequired = false, isFilled = false, disabled, rows, cols, value, onChange, ...rest } = props;
    const [isValueFilled, setIsValueFilled] = (0, react_1.useState)(isFilled);
    const handleChange = (e) => {
        if (e.target.value) {
            setIsValueFilled(false);
        }
        onChange && onChange(e);
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledTextAreaWrapper, { flexDirection: "column", fullWidth: true, alignItems: "flex-start", gap: "12px", ...{ ref }, "data-testid": "text-area-wrapper", children: [label ? ((0, jsx_runtime_1.jsx)(typography_1.Typography, { as: "label", variant: "body", size: "small", weight: "medium", colorScheme: {
                    type: 'text',
                    color: 'label',
                }, "data-testid": "text-area-label", isRequired: isRequired, children: label })) : null, (0, jsx_runtime_1.jsx)(styles_1.StyledTextArea, { disabled: disabled, ...{ messageType, rows, cols, value, isValueFilled }, ...props, ...rest, autoComplete: "off", "data-testid": "text-area", onChange: e => handleChange(e) }), (0, jsx_runtime_1.jsx)(styles_1.StyledTextAreaHelperText, { alignItems: "flex-start", justifyContent: "flex-start", ...{ messageType, helperText }, "data-testid": "text-area-helper-text", children: (0, jsx_runtime_1.jsx)(typography_1.Typography, { variant: "body", size: "small", as: "small", weight: "medium", colorScheme: {
                        type: 'system',
                        color: messageType !== null && messageType !== void 0 ? messageType : 'info',
                    }, children: helperText && helperText }) })] }));
});
exports.TextArea.displayName = 'TextArea';
exports.default = exports.TextArea;
//# sourceMappingURL=text-area.js.map